import { bind } from 'app/utils/decorators/decoratorUtils';
import EntityLayer from './EntityLayer';
import { get } from 'app/utils/lo/lo';
import { Heatmap as HeatmapLayer } from 'ol/layer.js';
import { isDefined } from 'app/utils/utils';
import { calculateSubLayerZIndex, applyLayerZIndex } from 'app/config/layerZIndexConfig';

class HeatMapLayer extends EntityLayer {
    parentLayer;
    layer;
    olMap;

    constructor(info, olMap, layer) {
        super(info);
        this.parentLayer = layer;
        this.layerId = get(info, 'layerId' || '');
        this.olMap = olMap;
        
        const parentZIndex = layer?.zIndex;
        this.zIndex = calculateSubLayerZIndex(parentZIndex, 'heatmap');
        
        this.createHeatmapLayer();
        this.parentLayer.addHeatMapLayer(this);
    }

    @bind
    createHeatmapLayer() {
        const { id, heatmap, visible, opacity } = this.info;
        const { valBlur, valRadius } = heatmap || {};

        const isheatMapLayer = this.olMap?.findLayerByType(`${id}`, 'heatmap') || this.olMap?.findLayer('allLayers', 'heat map layer');
        if (isheatMapLayer) this.olMap?.getMap()?.removeLayer(isheatMapLayer);
        
        const parentZIndex = this.parentLayer?.zIndex;
        const heatmapZIndex = calculateSubLayerZIndex(parentZIndex, 'heatmap');
        this.zIndex = heatmapZIndex;

        this.layer = new HeatmapLayer({
            title: 'heat map layer',
            visible,
            opacity: opacity > 1 ? 1 : opacity,
            zIndex: heatmapZIndex,
            attributes: {
                id: this.info?.id,
                type: 'heatmap',
                subtitle: 'entities',
                layerType: 'entity-layer',
                iconName: 'things',
                iconType: 'af',
                noLocationPins: [],
                parentLayerId: this.parentLayer?.layerId 
            },
            source: this.getDataSource(),
            blur: isDefined(valBlur) ? valBlur : 40,
            radius: isDefined(valRadius) ? valRadius : 40,
        });
        
        this.olMap.getMap().addLayer(this.layer);
    }

    @bind
    clearHeatMapSource() {
        const dataSource = this.getDataSource();
        dataSource.clear();
        if (dataSource?.getSource()) {
            dataSource?.getSource().clear();
        }
    }

    @bind
    getHeatMapLayer() {
        return this.layer;
    }

    @bind
    updateZIndex() {
        const parentZIndex = this.parentOriginalZIndex || this.parentLayer?.zIndex;
        const heatmapZIndex = calculateSubLayerZIndex(parentZIndex, 'heatmap');
        
        this.zIndex = heatmapZIndex;
        applyLayerZIndex(this.layer, heatmapZIndex);
        return heatmapZIndex;
    }

    /**
     * Stores the parent layer's original z-index for preserving correct hierarchy
     * when layers are updated and sub-layers are recreated
     */
    storeParentOriginalZIndex(originalZIndex) {
        if (typeof originalZIndex === 'number') {
            this.parentOriginalZIndex = originalZIndex;
            this.updateZIndex();
        }
    }
}

export default HeatMapLayer;
